// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"9ca340df","453":"3884a5f5"}[chunkId] + ".chunk.js";
};